import type { Editor } from 'slate';

import { isAlineEditor } from '../../slate-api';
import type { UUID } from '../../types/type-helpers';

export const authorizationQueries = {
  /**
   * The assignee may always fill their own field and anyone may fill an unassigned one. A user
   * with edit rights may also fill someone else's field until the workflow is sent for signature;
   * Signed and Complete count as sent.
   */
  isUserAuthorizedToCompleteNonSigField(
    editor: Editor,
    options: {
      assigneeId: UUID | null;
    }
  ): { isUserAuthorized: boolean } {
    const { assigneeId } = options;
    if (!isAlineEditor(editor)) return { isUserAuthorized: false };

    const isUnassigned = !assigneeId;
    const isUserAssignee = editor.userState?.editingUserId === assigneeId;
    const isPreSigning = editor.userState?.wasSentForSignature === false;
    const canFillOthersField = isPreSigning && editor.userState?.canEditDocument === true;

    return { isUserAuthorized: isUnassigned || isUserAssignee || canFillOthersField };
  },

  isUserAuthorizedToCompleteSigField(
    editor: Editor,
    options: { assigneeId: UUID }
  ): { isUserAuthorized: boolean } {
    const { assigneeId } = options;
    if (!isAlineEditor(editor)) return { isUserAuthorized: false };

    const isUserAssignee = editor.userState?.editingUserId === assigneeId;

    return { isUserAuthorized: isUserAssignee };
  },
};
